import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import cs from 'classnames';

import { APP_CURRENCY_SYMBOL } from 'constants/commons';
import { FREE_JOBS_AMOUNT } from 'constants/jobsSettings';

import styles from './SubscriptionPaidFeatures.module.scss';
import { JOB_SUBSCRIPTION_MONTHLY_PRICE } from './constants';

interface SubscriptionPaidFeaturesProps {
  className?: string;
}

const SubscriptionPaidFeatures: FC<SubscriptionPaidFeaturesProps> = ({
  className
}: SubscriptionPaidFeaturesProps) => {
  const { t } = useTranslation();
  return (
    <section className={cs(styles.wrap, [className])}>
      <div className={styles.benefitsSection}>
        <div className={styles.pricingInfo}>
          <div className={styles.freeJob}>
            <span className={styles.freeLabel}>{t('label.free')}</span>
            <span className={styles.freeText}>
              {t('payment.freeJobPosting', { amount: FREE_JOBS_AMOUNT })}
            </span>
          </div>
          <div className={styles.pricingDivider}>
            <div className={styles.dividerLine}></div>
            <span className={styles.dividerText}>{t('common.then')}</span>
            <div className={styles.dividerLine}></div>
          </div>
          <div className={styles.paidJobs}>
            <span className={styles.price}>
              {APP_CURRENCY_SYMBOL}
              {JOB_SUBSCRIPTION_MONTHLY_PRICE}
              <span className={styles.priceUnit}>/{t('common.month')}</span>
            </span>
            <span className={styles.priceText}>
              {t('common.perAdditionalJob')}
            </span>
          </div>
        </div>
        {/* <div className={styles.benefitsTitle}>
          Each additional job includes access to premium features:
        </div> */}

        {/* <div className={styles.benefitsList}>
          {SUBSCRIPTION_PAID_FEATURES.map((feature, index) => (
            <div className={styles.benefitItem} key={index}>
              <div className={styles.benefitIcon}>
                <CrownIcon />
              </div>
              <span className={styles.benefitText}>
                {t(feature.text)}
                {feature.extraText && <i>{t(feature.extraText)}</i>}
              </span>
            </div>
          ))}
        </div> */}
      </div>
    </section>
  );
};

export default SubscriptionPaidFeatures;
